import React from 'react'

import { PageTitle } from '@/layout-components'
import { ExampleWrapperSeamless } from '@/layout-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import MonthlyLimit from '@/housefolios-components/LaunchpadComponents/monthlyLimit'
import BonusProperties from '@/housefolios-components/LaunchpadComponents/bonusProperties'
import SaveMoney from '@/housefolios-components/Billing/SaveMoney'
import CancelPlanButton from '@/housefolios-components/TitleButtons/CancelPlanButton'
import {
  Grid,
  Box,
  Paper,
  Typography,
  Divider,
  Button,
} from '@mui/material'
import withSession from '@/housefolios-components/Session/withSession'
import TransactionsTable from '@/housefolios-components/Billing/TransactionsTable'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'
import {
  GET_ARTICLE,
  GET_ARTICLES,
} from '@/housefolios-components/Affiliate/queries'
// Centralized lodash imports - much cleaner!
import { isEmpty, map } from '@/utils/lodash'
import { Link as RouterLink } from 'react-router'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

function ArticlePage(props) {
  const { id = '' } = useParams()
  const affiliateId = props?.session?.me?.activeOrg?.isAffiliate?._id

  const { data, loading, error } = useQuery(GET_ARTICLE, {
    variables: {
      id,
    },
  })

  const { data: articlesData } = useQuery(GET_ARTICLES, {
    variables: { affiliateId: affiliateId },
    skip: !affiliateId,
  })

  const { article = {} } = data || {}
  const { articles = [] } = articlesData || {}
  const relatedArticles = articles.filter((a) => a._id !== id)

  if (loading) return <LoadingSkeleton variant="article" />
  // if (isEmpty(article))
  return (
    <>
      <PageTitle
        titleHeading={article?.name}
        // titleDescription="Make sure your information is up to date"
        icon={
          <FontAwesomeIcon
            style={{ fontSize: 30 }}
            icon={['far', 'file-lines']}

            sx={{ color: '#368cff' }}
          />
        }
      >
        {/* Meta info under the title */}
        {article?.updatedAt && (
          <Typography
            variant="subtitle2"
            sx={{
              color: 'text.secondary',
              mt: 1,
            }}
          >
            Last updated:{' '}
            {new Date(article.updatedAt).toLocaleDateString()}
          </Typography>
        )}
      </PageTitle>
      <ExampleWrapperSeamless>
        <Grid
          container
          direction="row"
          spacing={4}
          sx={{
            alignItems: 'flex-start',
          }}
        >
          {/* Mini Training Panel */}
          <Grid size={{ xs: 12, md: 4, lg: 3 }}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 3,
                bgcolor: 'background.paper',
                minHeight: 200,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                <FontAwesomeIcon
                  icon={['fas', 'graduation-cap']}

                  style={{ marginRight: 10, fontSize: 22 }}
                  sx={{ color: '#368cff' }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  Training
                </Typography>
              </Box>
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  mb: 2,
                }}
              >
                Explore more training articles:
              </Typography>
              <Divider sx={{ mb: 2 }} />
              {relatedArticles.length === 0 ? (
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.disabled',
                  }}
                >
                  No other articles yet.
                </Typography>
              ) : (
                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  {map(relatedArticles, (a) => (
                    <Box
                      key={a._id}
                      component="li"
                      sx={{
                        mb: 1,
                        listStyle: 'none',
                        '&:hover a': {
                          color: 'primary.main',
                          textDecoration: 'underline',
                        },
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'background 0.2s',
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                        cursor: 'pointer',
                        '&:hover': { bgcolor: 'action.hover' },
                      }}
                    >
                      <FontAwesomeIcon
                        icon={['far', 'file-lines']}
                        style={{
                          marginRight: 8,
                          fontSize: 16,
                          color: '#90caf9',
                        }}
                      />
                      <Typography
                        component={RouterLink}
                        to={`/articles/${a._id}`}
                        variant="body2"
                        sx={{
                          color: 'text.primary',
                          textDecoration: 'none',
                          flex: 1,
                        }}
                      >
                        {a.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
              <Divider sx={{ my: 2 }} />
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                component={RouterLink}
                to="/training"
                sx={{ borderRadius: 2, fontWeight: 600 }}
                startIcon={
                  <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                }
              >
                View All Training
              </Button>
            </Paper>
          </Grid>
          {/* Article Content */}
          <Grid size={{ xs: 12, md: 8, lg: 9 }}>
            <Box
              sx={{
                width: '100%',
                maxWidth: 900,
                mx: 'auto',
                px: { xs: 0, sm: 2, md: 4 },
                py: 3,
              }}
            >
              <Paper
                elevation={4}
                sx={{
                  p: { xs: 2, sm: 4 },
                  borderRadius: 4,
                  boxShadow: 6,
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: article?.content,
                  }}
                />
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </ExampleWrapperSeamless>
    </>
  )
}

export default withSession(ArticlePage)
